import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingService {
  private pendingRequests = 0;
  private readonly pendingRequests$ = new BehaviorSubject<number>(0);

  readonly loading$ = this.pendingRequests$.asObservable();

  start() {
    this.pendingRequests += 1;
    this.pendingRequests$.next(this.pendingRequests);
  }

  end() {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    this.pendingRequests$.next(this.pendingRequests);
  }
}
